import type { ReactElement } from "react"
import type { Control, FieldPath, FieldValues } from "react-hook-form"
import { useController } from "react-hook-form"

import { CurrencyInput } from "@/components/CurrencyInput/CurrencyInput"

interface FormCurrencyInputProps<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>> {
  control: Control<TFieldValues>
  name: TName
  label?: string
  placeholder?: string
  helperText?: string
  fullWidth?: boolean
  disabled?: boolean
  className?: string
  onChange?: (value: string) => void
  "data-testid"?: string
}

export const FormCurrencyInput = <TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>({
  control,
  name,
  helperText,
  onChange,
  ...props
}: FormCurrencyInputProps<TFieldValues, TName>): ReactElement => {
  const {
    field,
    fieldState: { error },
  } = useController({ name, control })

  const handleChange = (value: string) => {
    field.onChange(value)
    onChange?.(value)
  }

  return (
    <CurrencyInput
      {...props}
      value={field.value ?? ""}
      onChange={handleChange}
      onBlur={field.onBlur}
      error={!!error}
      helperText={error?.message ?? helperText}
    />
  )
}
